import {SPAN_ATTR_TASK_DEDUPED} from '../constants';

/**
 * Maintains task insert order but (when dedupe==true) will skip earlier tasks
 * if there's another task for the same element enqueued later
 */
export default class Queue {
	constructor(dedupe, doNotDedup = [], whenQueueIsEmptyForElementCb) {
		this._els = new WeakMap();
		this._tasks = [];
		this._dedupe = dedupe;
		this._doNotDedup = doNotDedup;
		this._whenQueueIsEmptyForElementCb = whenQueueIsEmptyForElementCb;
	}

	push(task) {
		const {el} = task.meta;
		this._els.set(el, this.sizeForElement(el) + 1);
		this._tasks.push(task);
	}

	// this value may be a little misleading because it doesn't account for
	// possible task duplicates
	get length() {
		return this._tasks.length;
	}

	sizeForElement(el) {
		return this._els.get(el) || 0;
	}

	shift() {
		while (this._tasks.length) {
			const task = this._tasks.shift();
			const {el} = task.meta;
			const existingCount = this._els.get(el);
			if (existingCount === 1) {
				this._els.delete(el);
				if (this._whenQueueIsEmptyForElementCb) this._whenQueueIsEmptyForElementCb(el);
			} else {
				this._els.set(el, existingCount - 1);
			}

			if (
				existingCount === 1 ||
				!this._dedupe ||
				this._doNotDedup.indexOf(task.type) !== -1 ||
				!el.isConnected
			)
				return task;
			else {
				if (task.meta?.span)
					task.meta.span.addEvent(SPAN_ATTR_TASK_DEDUPED, {
						type: task.type,
						queueSize: this._tasks.length
					});
			}
		}
	}
}
